import React from "react"; 
import { Link } from "react-router-dom";

const ServiceList = [
    {
        link: "/local-moving",
        name: "Local Moving",
    },
    {
        link: "/long-distance-moving",
        name: "Long Distance Moving",
    },
    {
        link: "/commercial-moving",
        name: "Commercial Moving",
    },
    {
        link: "/full-packing",
        name: "Full Packing",
    }, 
];
const SideService = () => {
    return (
        <div className="side-service">
            <h4>All Services</h4>
            <ul>
                {ServiceList.map((ls, index) =>
                    <li><Link to={ls.link}>{ls.name}</Link></li>
                )}
            </ul>
        </div>
    );
}

export default SideService;